<template>
  <div class="car-main-tab-content car-contact-request car-reduced-width car-conversation">
    <back-btn v-if="!history" />

    <div class="car-content-introduction" v-if="initialMessageSent || history">
      <span class="car-headline" v-if="!loading">
        {{$t('request.title')}}
      </span>
      <p>
        {{$t('request.description')}}
      </p>
    </div>
    <div class="car-content-introduction" v-else>
      <span class="car-headline" v-if="!loading">
        {{$t('request.title')}}
      </span>
      <p>
        {{$t('request.successMsg')}}
      </p>
    </div>

    <div class="car-form-container" v-if="!loading">
      <div class="car-contact-form" v-if="!initialMessageSent && !history">
        <div class="car-form-item">
          <label for="email">{{$t('request.email')}}*</label>
          <input type="text"
                 id="email"
                 data-js="email__input"
                 v-model="form.email"
                 :class="{'car-filled': form.email, 'car-error': !$v.form.email.required && $v.form.email.$error}"
                 v-bind:placeholder="$t('request.email')+$t('*')">
          <div class="car-error-message" v-if="!$v.form.email.required && $v.form.email.$error">
            {{$t('request.errors.email')}}
          </div>
        </div>
        <div class="car-form-item">
          <label for="phone">{{$t('request.phone')}}</label>
          <input type="text"
                 id="phone"
                 data-js="phone__input"
                 v-model="form.phone"
                 :class="{'car-filled': form.phone}"
                 v-bind:placeholder="$t('request.phone')">
        </div>
        <div class="car-form-item">
          <label for="message">{{$t('request.message')}}*</label>
          <textarea type="text"
                    rows="3"
                    id="message"
                    data-js="message__input"
                    v-model="form.message"
                    :class="{'car-filled': form.message, 'car-error': !$v.form.message.required && $v.form.message.$error}"
                    v-bind:placeholder="$t('request.message')+$t('*')">
          </textarea>
          <div class="car-error-message" v-if="!$v.form.message.required && $v.form.message.$error">
            {{$t('request.errors.message')}}
          </div>
        </div>
        <div class="car-info-box car-selection-overview">
          <ul>
            <li>{{$t('request.note1')}}</li>
            <li>{{$t('request.note2')}}</li>
          </ul>
        </div>
        <div v-if="requestError" class="car-error-message">{{$t('errors.unknown')}}</div>
        <div class="car-form-buttons car-buttons">
          <primary-btn
            @click="postMessage"
            class="car-btn-primary"
            data-js="conversation-btn"
            :loading="loading">
            {{$t('request.button.sendMessage')}}
          </primary-btn>
          <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
        </div>
      </div>
      <div v-else-if="history">
        <div class="car-conversation-container">
          <message-list />
        </div>

        <div class="car-contact-form">
          <div class="car-form-item">
            <label>
              {{$t('conversation.inputTextLabel')}}*
            </label>
            <textarea rows="5"
                      data-js="message__input"
                      v-model="message"
                      v-bind:placeholder="$t('conversation.inputTextLabel')+'*'" />
          </div>
          <div class="car-form-buttons car-buttons">
            <primary-btn
              @click="postMessage"
              class="car-btn-primary"
              data-js="conversation-btn"
              :loading="loading">
              {{$t('conversation.buttons.sendMessage')}}
            </primary-btn>
            <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
          </div>
        </div>
      </div>
    </div>
    <spinner v-else />
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import { each, get } from 'lodash'
import MessageList from '@/components/conversation/MessageList'
import tabs from '@/constants/tabs'
import utils from '@/util/utils'
import PrimaryBtn from '@/components/PrimaryBtn'
import moment from 'moment'
import BackBtn from '@/components/BackBtn';

const { required, email } = require('vuelidate/lib/validators')

export default {
  name: 'Conversation',
  data: function () {
    return {
      form: {
        email: this.$store.getters['offer/booking'].emailAddress,
        phone: this.$store.getters['offer/booking'].phone
      },
      initialMessageSent: false,
      requestError: false,
      loading: false,
      history: false,
      message: ''
    }
  },
  validations: function () {
    if (this.history) {
      return {
        message: {
          required
        }
      }
    } else {
      return {
        form: {
          email: {
            required,
            email
          },
          message: {
            required
          }
        }
      }
    }
  },
  methods: {
    validateForm: function () {
      this.$v.$touch()
    },
    postMessage: function () {
      this.validateForm()
      if (this.$v.$invalid || this.loading) {
        return
      }
      this.requestError = false
      this.loading = true
      if (!this.thread) {
        return this.postThread()
      }
      let message = {
        attrs: {
          type: 'Message'
        },
        authorId: this.customer.id,
        message: this.message
      }
      return this.$store.dispatch('conversation/postMessage', {
        accessToken: this.$route.params.token || this.serviceCase.messageAccessToken,
        message: message
      })
        .catch(() => {
          this.requestError = true
        })
        .finally(() => {
          this.loading = false
          this.message = ''
        })
    },
    postThread: function () {
      let attrs = {
        type: 'Message',
        offerSearchKey: get(this.offers, '[0].offerSearchKey')
      }
      each(this.selectedService, (service, key) => {
        attrs[`service-${key}`] = service.id
      })
      this.selectedEquipments.forEach((equipment, index) => {
        if (equipment.externalId && equipment.externalId.split('-').length) {
          let equipmentCode = equipment.externalId.split('-')[equipment.externalId.split('-').length - 1]
          if (equipment.externalId.split('-')[0] !== 'FUEL_ID') attrs[`equipment-${index}`] = equipmentCode
        }
      })
      this.setVehicleDetails(attrs)
      let thread = {
        attrs: attrs,
        bookedOfferKey: this.booking.key,
        contactRequestText: this.form.message,
        locationId: this.booking.locationId || SMP_CONFIG.contextConfig.locationId,
        source: {
          applicationSource: 'CONSUMER',
          dataSource: 'CONTACT_REQUEST'
        },
        userInfo: {
          email: this.form.email,
          firstName: this.booking.givenname || '',
          lastName: this.booking.surname || '',
          phone: this.form.phone || this.booking.phone
        },
        vehicleId: this.selectedVehicle && this.selectedVehicle.id,
        offerKey: (this.selectedOffer && !this.selectedOffer.empty) ? this.selectedOffer.offerKey : null
      }
      this.loading = true
      this.$store.dispatch('conversation/postThread', thread)
        .then(() => {
          this.initialMessageSent = true
        })
        .catch(() => {
          this.requestError = true
        })
        .finally(() => {
          this.loading = false
          this.message = ''
        })
    },
    setVehicleDetails: function (attrs) {
      if (this.hsnTsnData.hsn) {
        each(this.hsnTsnData, (value, key) => {
          attrs[`${key}`] = value
        })
        delete attrs.vehicle
        delete attrs.equipment
      } else if (this.vinIdentificationData && this.vinIdentificationData.vin) {
        each(this.vinIdentificationData, (value, key) => {
          attrs[`${key}`] = value
        })
      } else if (this.catalogSelectionRegistrationDate) {
        attrs.month = moment(this.catalogSelectionRegistrationDate).month() + 1
        attrs.year = moment(this.catalogSelectionRegistrationDate).year()
      }
      if (this.mileage) attrs.mileage = this.mileage
    }
  },
  created() {
    let token = this.$route.params.token || this.serviceCase.messageAccessToken
    if (token) {
      this.history = true
      this.loading = true
      let params = {
        accessToken: token
      }
      this.$store.dispatch('conversation/getThreadDetail', params)
        .then(() => {
          let promises = []
          if (this.thread) {
            let threadPromise = this.$store.dispatch('conversation/getThreadMessages', this.thread.accessToken)
            promises.push(threadPromise)
          }
          if (!this.serviceCase.messageAccessToken) {
            let serviceCasePromise = this.$store.dispatch('serviceCase/getCaseByToken', token).then((res) => {
              let key = utils.getLastestBookedOfferKey(res.data)
              if (key) {
                tabs.main[0].href = `/booking/${key}`
                this.$store.dispatch('tab/setTabs', tabs.main)
              }
            })
            promises.push(serviceCasePromise)
          }
          return Promise.all(promises)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  components: {
    BackBtn,
    PrimaryBtn,
    MessageList,
    Spinner
  },
  computed: {
    booking() {
      return this.$store.getters['offer/booking']
    },
    offers() {
      return this.$store.getters['offer/offers']
    },
    serviceCase() {
      return this.$store.getters['serviceCase/serviceCase']
    },
    selectedOffer() {
      return this.$store.getters['offer/selectedOffer']
    },
    selectedService() {
      return this.$store.getters['vehicleServices/selectedServices']
    },
    selectedVehicle() {
      return this.$store.getters['vehicleIdentification/vehicleType']
    },
    hsnTsnData() {
      return this.$store.getters['wizardData/hsnTsnData']
    },
    catalogSelectionRegistrationDate() {
      return this.$store.getters['vehicleIdentification/registrationDate']
    },
    vinIdentificationData() {
      return this.$store.getters['wizardData/vinIdentificationData']
    },
    mileage() {
      return this.$store.getters['wizardData/mileage']
    },
    selectedEquipments() {
      return this.$store.getters['vehicleEquipments/selectedEquipments']
    },
    customer() {
      if (!this.thread.participants[0].locationId) {
        return this.thread.participants[0]
      } else {
        return this.thread.participants[1]
      }
    },
    thread() {
      return this.$store.getters['conversation/thread']
    }
  }
}
</script>
